import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { useTheme } from '@material-ui/core/styles';
import FacetFacNegative from 'Icons/Brand/FacetFacNegative';
import { useOnboardingContext } from '../../../../../Contexts/OnboardingContext';
import OnboardingStepIndicator from './SignUpFlowStepIndicator';

const SignUpFlowStepIndicatorPicker = () => {
  const { householdResource } = useOnboardingContext();
  const theme = useTheme();

  return pickFunction(householdResource, {
    [fr.relationships.hasDigitalOnboarding.name]: () => {
      return (
        <OnboardingStepIndicator />
      );
    },
    [fr.relationships.default.name]: () => {
      return (
        <FacetFacNegative
          style={{
            width: 55,
            height: 60,
            marginBottom: theme.spacing(4),
          }}
        />
      );
    },
  });
};

export default SignUpFlowStepIndicatorPicker;
